/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  FC,
  useCallback,
  Dispatch,
  SetStateAction,
  useState,
  useEffect,
} from 'react'
import { useSelector } from 'react-redux'
import { useAnalytics } from 'reactfire'

import PhotoPicker from '../../../components/PhotoPicker'
import { iRootState } from '../../../store'
import { PhotoIcon, EditPhotoIcon } from '../../../components/Icons'

import { Wrap, EditWrap, ProfileImage } from './styled'

import { analyticsEvents } from 'src/constants/analytics/events'

type PhotoProps = {
  setIsLoading: Dispatch<SetStateAction<boolean>>
  uid: string
}
const stateSelector = (state: iRootState) => ({
  profilePicture: state.user.data?.profilePicture,
  profileComplete: state.user.data?.profileComplete,
})

const Photo: FC<PhotoProps> = ({ setIsLoading, uid }) => {
  const [loadPhoto, setLoadPhoto] = useState(false)
  const { logEvent } = useAnalytics()

  const { profilePicture, profileComplete } = useSelector(stateSelector)

  useEffect(() => {
    profilePicture && setLoadPhoto(true)
  }, [profilePicture])

  const onUpdate = useCallback(
    ({ data, state }) => {
      if (state === 'loading') {
        console.log('Uploading photo')
        setIsLoading(true)
      }
      if (state === 'error') {
        console.log('Error while uploading photo')
        setIsLoading(false)
      }
      if (state === 'success') {
        console.log('Photo uploaded:', data)
        setLoadPhoto(true)
        setIsLoading(false)
        if (!profileComplete) {
          logEvent(analyticsEvents.onboardingProfilePhotoUploaded)
        }
      }
    },
    [logEvent, profileComplete, setIsLoading]
  )

  return (
    <Wrap>
      <PhotoPicker onUpdate={onUpdate} uid={uid || ''} />
      {!loadPhoto && <PhotoIcon />}

      {loadPhoto && (
        <>
          <ProfileImage src={profilePicture} alt="Profile" />
          <EditWrap>
            <EditPhotoIcon />
            <PhotoPicker onUpdate={onUpdate} uid={uid || ''} />
          </EditWrap>
        </>
      )}
    </Wrap>
  )
}

export default Photo
